import { HeaderHeightContext } from "@react-navigation/elements";
import { useContext } from "react";
function useHeaderHeight() {
  var _useContext;
  return (_useContext = useContext(HeaderHeightContext)) !== null && _useContext !== void 0 ? _useContext : 0;
}
export {
  useHeaderHeight
};
//# sourceMappingURL=useHeaderHeight.native.js.map
